const publicRuntimeEnvKeys = [
  "VITE_SUPABASE_URL",
  "VITE_SUPABASE_ANON_KEY",
  "VITE_SUPABASE_FUNCTIONS_URL",
  "VITE_SITE_URL",
  "VITE_IMPORT_FILE_SIZE_LIMIT_BYTES",
  "VITE_IMPORT_MAX_PAGE_COUNT",
  "VITE_STORY_IMPORT_PROGRESS_POLL_MS",
  "VITE_SENTRY_DSN",
  "VITE_SENTRY_ENVIRONMENT",
  "VITE_SENTRY_RELEASE",
  "VITE_SENTRY_TRACES_SAMPLE_RATE",
] as const;

export type PublicRuntimeEnvKey = typeof publicRuntimeEnvKeys[number];

export type PublicRuntimeEnv = Partial<Record<PublicRuntimeEnvKey, string>>;

function getWindowRuntimeConfig(): PublicRuntimeEnv {
  if (typeof window === "undefined" || !window.__APP_CONFIG__) {
    return {};
  }

  return window.__APP_CONFIG__;
}

export function getBrowserEnvSource(
  env: Record<string, unknown> = import.meta.env as Record<string, unknown>,
) {
  return {
    ...env,
    ...getWindowRuntimeConfig(),
  };
}

export function getPublicRuntimeEnvKeys() {
  return [...publicRuntimeEnvKeys];
}
